import { IMensagemTemplate } from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    ICadastroTemplateMensagemAtiva,
    TemplatesResponse,
} from "../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarTemplateMensagemAtivaService() {
    return Service(
        Axios.get<Array<IMensagemTemplate>>(
            `/helpdesk/templatemensagemativa/listartemplatemensagemativa`
        )
    );
}

export async function ObterTemplateMensagemAtivaService(
    idDocumentoTemplate: number
) {
    return Service(
        Axios.get<ICadastroTemplateMensagemAtiva>(
            `/helpdesk/templatemensagemativa/obtertemplatemensagemativa?idDocumentoTemplate=${idDocumentoTemplate}`
        )
    );
}

export async function CadastrarTemplateMensagemAtivaService(
    requestBody: ICadastroTemplateMensagemAtiva
) {
    return Service(
        Axios.post(
            `/helpdesk/templatemensagemativa/cadastrartemplatemensagemativa`,
            requestBody
        )
    );
}

export async function EditarTemplateMensagemAtivaService(
    idDocumentoTemplate: number,
    requestBody: ICadastroTemplateMensagemAtiva
) {
    return Service(
        Axios.put(
            `/helpdesk/templatemensagemativa/editartemplatemensagemativa?idDocumentoTemplate=${idDocumentoTemplate}`,
            requestBody
        )
    );
}

export async function RemoverTemplateMensagemAtivaService(
    idDocumentoTemplate: number
) {
    return Service(
        Axios.delete(
            `/helpdesk/templatemensagemativa/removertemplatemensagemativa?idDocumentoTemplate=${idDocumentoTemplate}`
        )
    );
}
export async function RemoverVariavelMensagemAtivaService(
    idVariavelTemplate: number
) {
    return Service(
        Axios.delete(
            `/helpdesk/templatemensagemativa/removervariavelmensagemativa?idVariavelTemplate=${idVariavelTemplate}`
        )
    );
}

export async function RemoverVariaveisMensagemAtivaService(
    requestBody: Array<number>
) {
    return Service(
        Axios.delete(
            `/helpdesk/templatemensagemativa/removervariaveismensagemativa`,
            {
                data: requestBody,
            }
        )
    );
}

export async function ObterValoresVariaveisMensagemAtivaService(
    nrCliente: string,
    idTemplate: number
) {
    return Service(
        Axios.post(
            `/helpdesk/templatemensagemativa/obtervaloresvariaveismensagemativa?nrCliente=${nrCliente}&idTemplate=${idTemplate}`
        )
    );
}

export async function SendTemplateTwilioService(
    template: string,
    twilioTemplate:
        | "TEXT"
        | "MEDIA"
        | "QUICK_REPLY"
        | "CALL_TO_ACTION"
        | "LIST_PICKER"
        | "CARD"
        | "WHATSAPP_CARD"
        | "AUTHENTICATION"
) {
    return Axios.post(
        `/helpdesk/twilio/sendtemplatetwilio?template=${template}&twilioTemplate=${twilioTemplate}`
    );
}

export async function ListarTemplateTwilioService() {
    return Axios.get<TemplatesResponse>(
        `/helpdesk/twilio/listartemplatestwilio`
    );
}

export async function DeleteTemplateTwillioService(template: string) {
    return Service(
        Axios.delete(
            `/helpdesk/twilio/deletetemplatetwilio?template=${template}`
        )
    );
}
